import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MLBundleCart } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLScriptComponent } from 'ml-components-common-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';

function MLGatewayCompRaterBridgeQuoteSummaryPage(props) {
    const { authHeader } = useAuthentication();
    const [scriptML, updateScriptML] = React.useState("");
    const { bridgedQuoteData } = props;

    useEffect(() => {
        const loadScript = async () => {
            if (bridgedQuoteData && bridgedQuoteData.submissions && bridgedQuoteData.submissions.length > 0) {
                const firstRiskState = bridgedQuoteData.submissions[0].baseState
                
                LoadSaveService.getScript('FirstWizardPage', { state: firstRiskState }, authHeader)
                    .then((lines) => {
                        if(lines.length > 1){
                            updateScriptML([lines[0]]);
                        }
                        else{
                            updateScriptML(lines);
                        }
                    });
                }
        }

        loadScript();
    },[bridgedQuoteData, authHeader]);

    return (
        <div>
            <MLBundleCart bridgedQuoteData={bridgedQuoteData}/>
            <MLScriptComponent mlScript={scriptML} />
        </div>
    );
}

MLGatewayCompRaterBridgeQuoteSummaryPage.propTypes = {
    bridgedQuoteData: PropTypes.shape({}).isRequired
};
export default MLGatewayCompRaterBridgeQuoteSummaryPage;
